// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1osq{width:100%}\n._1e02idpf{inset-inline-start:0}\n._kqswstnw{position:absolute}\n._lcxvglyw{pointer-events:none}\n._rjxpidpf{inset-inline-end:0}\n._tzy4idpf{opacity:0}\n._u7coidpf{inset-block-end:0}", ""]);
// Exports
module.exports = exports;
